import { Route, Router, Switch } from 'react-router-dom';

import { history } from '../core/state/history';
import {
  STYLE_GUIDE,
  HOME_ROUTE,
  LOGIN_ROUTE,
  PROJECT_LISTING,
  PROJECT_BOOKINGS,
  PROJECT_DOCUMENTS,
  PROJECT_SETTINGS,
  INTERNAL_USERS,
  EXTERNAL_USERS,
  INTERNAL_USER_PROJECTS,
  NOTIFICATIONS,
  EXTERNAL_USER_CONTACTS,
  EXTERNAL_USER_PROJECTS,
  PROJECT_MANAGEMENT,
  PROJECT_ROLES_INTERNAL,
  PROJECT_ROLES_EXTERNAL,
  PROFILE,
  COMPANY_CONTACTS,
  BARRIER_MANAGEMENT,
  FORBIDDEN,
  NOTIFICATIONS_EMAIL,
  BARRIER_LOGS
} from '../core/constants/routes';

import StyleGuide from '../pages/styleguide/StyleGuide';
import ErrorPage from '../pages/error-page/ErrorPage';
import Login from '../pages/login/Login';
import ProjectListing from '../pages/project-listing/ProjectListing';
import PageWrap from '../components/page-wrap/PageWrap';
import { PrivateRoute } from './components/PrivateRoute';
import ProjectSettings from '../pages/project-settings/ProjectSettings';
import Bookings from '../pages/bookings/Bookings';
import InternalUsers from '../pages/internal-users/InternalUsers';
import ExternalUsers from '../pages/external-users/ExternalUsers';
import InternalUserProjects from '../pages/internal-users/internal-user-projects/InternalUserProjects';
import Notifications from '../pages/notifications/Notifications';
import Profile from '../pages/profile/Profile';
import ExternalUserContacts from '../pages/external-users/external-user-contacts/ExternalUserContacts';
import ExternalUserProjects from '../pages/external-users/external-user-projects-page/ExternalUserProjects';
import ProjectManagement from '../pages/project-management/ProjectManagement';
import ProjectInternalRoles from '../pages/project-internal-roles/ProjectInternalRoles';
import ProjectExternalRoles from '../pages/project-external-roles/ProjectExternalRoles';
import CompanyContacts from '../pages/company-contacts/CompanyContacts';
import Documents from '../pages/project-settings/documents/Documents';
import { isMobileScreenSize } from '../core/utils/isMobileScreenSize';
import LoginMobileScreen from '../pages/login/LoginMobileScreen/LoginMobileScreen';
import ProjectListingDesktop from '../pages/project-listing/project-listing-desktop/ProjectListingDesktop';
import BookingsMobileScreen from '../pages/bookings/bookings-mobile-screen/BookingsMobileScreen';
import BarrierManagement from '../pages/barrier-management/BarrierManagement';
import ExternalUserNotificationEmails from '../pages/external-users/external-user-notification-emails/ExternalUserNotificationEmails';
import BarrierLogs from '../pages/barrier-logs/BarrierLogs';

export default () => (
  <Router history={history}>
    <PageWrap>
      <Switch>
        <PrivateRoute path={HOME_ROUTE} component={isMobileScreenSize() ? ProjectListingDesktop : ProjectListing} exact />
        <PrivateRoute path={STYLE_GUIDE} component={StyleGuide} exact />
        <PrivateRoute path={PROJECT_LISTING} component={ProjectListing} exact />
        <PrivateRoute path={PROJECT_BOOKINGS} component={isMobileScreenSize() ? BookingsMobileScreen : Bookings} />
        <PrivateRoute path={PROJECT_SETTINGS} component={ProjectSettings} exact />
        <PrivateRoute path={INTERNAL_USERS} component={InternalUsers} exact />
        <PrivateRoute path={PROFILE} component={Profile} exact />
        <PrivateRoute path={EXTERNAL_USERS} component={ExternalUsers} exact />
        <PrivateRoute path={COMPANY_CONTACTS} component={CompanyContacts} exact />
        <PrivateRoute path={INTERNAL_USER_PROJECTS} component={InternalUserProjects} exact />
        <PrivateRoute path={NOTIFICATIONS} component={Notifications} exact />
        <PrivateRoute path={EXTERNAL_USER_CONTACTS} component={ExternalUserContacts} exact />
        <PrivateRoute path={EXTERNAL_USER_PROJECTS} component={ExternalUserProjects} exact />
        <PrivateRoute path={PROJECT_MANAGEMENT} component={ProjectManagement} exact />
        <PrivateRoute path={PROJECT_ROLES_INTERNAL} component={ProjectInternalRoles} exact />
        <PrivateRoute path={PROJECT_ROLES_EXTERNAL} component={ProjectExternalRoles} exact />
        <PrivateRoute path={PROJECT_DOCUMENTS} component={Documents} exact />
        <PrivateRoute path={BARRIER_MANAGEMENT} component={BarrierManagement} exact />
        <PrivateRoute path={NOTIFICATIONS_EMAIL} component={ExternalUserNotificationEmails} exact />
        <PrivateRoute path={BARRIER_LOGS} component={BarrierLogs} exact />
        <Route path={LOGIN_ROUTE} component={isMobileScreenSize() ? LoginMobileScreen : Login} exact />
        <Route path={FORBIDDEN}>
          <ErrorPage pageType={403} />
        </Route>
        <Route path="*">
          <ErrorPage pageType={404} />
        </Route>
      </Switch>
    </PageWrap>
  </Router>
);
